<template>
  <div>
    <el-input v-model="txtName" placeholder="请输入用户名"></el-input>
    <el-input v-model="txtPassword" placeholder="请输入密码"></el-input>
    <el-button @click="onLogin">登录系統</el-button>
    <el-button @click="onGetYear">访问数据</el-button>
    <el-button @click="onGetExp">测试GET导出接口</el-button>
    <el-button @click="onGetExpPost">测试POST导出接口</el-button>
    <div v-if="tokenInfo">
      token:{{ tokenInfo }}
    </div>
    <div v-if="itemData && itemData.length > 0">
      刷新时间{{ dateshowtime }}
      <div v-for="(item, index) in itemData" :key="index">
        {{ item.semesterId }} | {{ item.name }}
      </div>
    </div>

    <div>
      <el-input v-model="itemData2.txtSemesterId" placeholder="请输入学期ID"></el-input>
      <el-button @click="onGetPost">测试POST的方式获取数据接口</el-button>
      <div v-if="itemData2.data && itemData2.data.length > 0">
        刷新时间{{ itemData2.time }}
        <div v-for="(item, index) in itemData2.data" :key="index">
          {{ item.semesterId }} | {{ item.courseIds }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { setToken, setRefreshToken, getToken, removeToken, removeRefreshToken } from '@/plugins/token.js';
export default {
  data() {
    return {
      txtName: '',
      txtPassword: '',
      itemData: [],
      tokenInfo: '',
      dateshowtime:null,

      itemData2:{
        data:[],
        txtSemesterId:null,
        time:new Date()
      }
    };
  },
  created() {

  },
  methods: {
    async onLogin() {
      let that = this;
      try {
        removeToken();
        removeRefreshToken();
        const res = await that.$request.post('/api/auth/token', {
          username: that.txtName,
          password: this.$md5(that.txtPassword)
        })
        // if (res.data.data.success != false) {
        //   // 保存登录凭证
        console.log(res.data.token.accessToken);
        that.$nextTick(() => {
          setToken(res.data.token.accessToken);
          setRefreshToken(res.data.token.refreshToken);
        });

        // }

      } catch (e) {
        console.log(e);
      }
    },
    async onGetYear() {
      let that = this;
      try {
      ajaxGet(that, '/api/admin/semester', null, function (r) {
        that.itemData=r;
        that.dateshowtime=timeTransform(new Date(),'YYYY-MM-DD HH:mm:ss')
      });
      } catch (e) {
        console.log(e);
      }
    },
    async onGetExp() {
      let that = this;
      try {
        ajaxExport(that, '/api/admin/classcadre/export', null, '测试导出接口.xlsx',function (r) {
        console.log(r);
      });
      } catch (e) {
        console.log(e);
      }
    },
    async onGetExpPost() {
      let that = this;
      try {
        ajaxPostExport(that, '/api/admin/student/exportphoto',null,'学生照片.zip',function (r) {
        console.log(r);
      });
      } catch (e) {
        console.log(e);
      }
    },
    onGetPost(){
      let that = this;
      let tpParams={
        semesterId: that.itemData2.txtSemesterId,
        type:1,
      }
      ajaxPostToGet(that, `/api/admin/academicrecord/class`, tpParams, function(resData) {
        that.itemData2.data = resData.items;
    });
    },
    onGetToken() {
      this.tokenInfo = getToken();
    }


  }
};
</script>

<style></style>
